export default __webpack_public_path__ + "static/button-spacing-after.light-f12651c73011045f509cc96a87c4dce53144bd2384efe5dcd6822cd12981ae7e.png";